import React, { useState, useEffect } from 'react';
import { findMessById } from '../../../firebase';
import ConnectModal from '../../util/ConnectModal';
import { useParams } from 'react-router-dom';

export default function MessDetails({ match }) {
    const {uid, mid} = useParams(); 
    const [info, setInfo] = useState();
    const [modalDetails, setModalDetails] = useState({
        id: "",
        type: "",
        typeId: ""
    })
    const [loading, setLoading] = useState(false);
    useEffect(() => {
        setLoading(true);
        findMessById(uid).then(res => {
            setLoading(false);
            if (res.details.length > 0) {
                let messInfo = res.details.find(d => d.id === mid);
                setInfo(messInfo);
            }
        }).catch(e => {
            setLoading(false);
        })
    }, [uid, mid]);
    return (
        <main id="main">
            <ConnectModal modalDetails={modalDetails} />
            <section id="portfolio-details" className="portfolio-details text-start">
                {info && <div className="container">
                    <div className="row gy-4">
                        <div className="col-lg-4">
                            <div className="portfolio-details-slider">
                                {info.pic.length>0 && <div className="text-center">
                                    <div id="messCarousal" className="carousel slide" data-bs-ride="carousel">
                                        <div className="carousel-indicators">
                                            <button type="button" data-bs-target="#messCarousal" data-bs-slide-to={0} className="active" aria-current="true" aria-label="Slide 1" />
                                            {info.pic.slice(1).map((_, index) => <button key={index} type="button" data-bs-target="#messCarousal" data-bs-slide-to={index + 1} />)}
                                        </div>
                                        <div className="carousel-inner">
                                            <div className="carousel-item active">
                                                <img src={info.pic[0]} className="d-block w-100" alt="..." />
                                            </div>
                                            {info.pic.slice(1).map((p, index) => <div key={index} className="carousel-item">
                                                <img src={p} className="d-block w-100" alt="..." />
                                            </div>)}
                                        </div>
                                        <button className="carousel-control-prev" type="button" data-bs-target="#messCarousal" data-bs-slide="prev">
                                            <span className="carousel-control-prev-icon" aria-hidden="true" />
                                            <span className="visually-hidden">Previous</span>
                                        </button>
                                        <button className="carousel-control-next" type="button" data-bs-target="#messCarousal" data-bs-slide="next">
                                            <span className="carousel-control-next-icon" aria-hidden="true" />
                                            <span className="visually-hidden">Next</span>
                                        </button>
                                    </div>
                                </div>}
                            </div>
                        </div>
                        <div className="col-lg-8">
                            <div className="portfolio-info">
                                <h3>
                                    <div className="row">
                                        <div className="col-5 col-sm-5">
                                            <span>{info?.type} Details</span>
                                        </div>
                                        <div className="col-7 col-sm-7 text-end">
                                            <button className="btn btn-warning "
                                                data-bs-toggle="modal" data-bs-target="#connectModal"
                                                onClick={() => setModalDetails({
                                                    id: uid,
                                                    typeId: mid,
                                                    type: info.type
                                                })}>Connect</button>
                                        </div>
                                    </div></h3>
                                <div className="row gy-3 pb-3">
                                    <div className="col-6 col-sm-6">
                                        <strong>For</strong>: <i>{info.for}</i>
                                    </div>
                                    <div className="col-6 col-sm-6">
                                        <strong>Rent</strong>: <i>{info.rent}</i>
                                    </div>
                                    <div className="col-6 col-sm-6">
                                        <strong>Area</strong>: <i>{info.area}</i>

                                    </div>
                                    <div className="col-6 col-sm-6">
                                        <strong>District</strong>: <i>{info.district}</i>

                                    </div>
                                    <div className="col-6 col-sm-6">
                                        <strong>State</strong>: <i>{info.state}</i>

                                    </div>
                                    <div className="col-6 col-sm-6">
                                        <strong>Pin</strong>: <i>{info.pin}</i>

                                    </div>
                                    <div className="col-12 col-sm-12">
                                        <strong>Review:</strong>
                                        {info.review && <span >
                                            {[...new Array(info.review)].map((r, index) => <i style={{ color: "#eb5d1e" }} key={index} className="bx bxs-star"></i>)}
                                            {[...new Array(5 - info.review)].map((r, index) => <i key={index} className="bx bx-star"></i>)}
                                        </span>}

                                    </div>
                                    <div className="col-12 col-sm-12">
                                        <strong>Information:</strong> <p>{info.information}</p>

                                    </div>
                                </div>
                            </div>

                        </div>
                    </div>
                </div>}
                {loading && <div className="d-flex justify-content-center" style={{ color: "#eb5d1e" }}>
                    <div className="spinner-border" role="status">
                        <span className="visually-hidden">Loading...</span>
                    </div>
                </div>}
            </section>
        </main>

    );
}
